// extracted by mini-css-extract-plugin
export var askAiIcon = "_px-9";
export var container = "_px-0";
export var groupSeparator = "_px-a";
export var highlight = "_px-4";
export var resultIcon = "_px-5";
export var resultItem = "_px-7";
export var resultSubtitle = "_px-3";
export var resultTitle = "_px-2";
export var resultsList = "_px-1";
export var searchGroup = "_px-6";
export var selected = "_px-8";